import * as React from 'react';
import * as _ from 'lodash/fp';
import styled from 'styled-components';


import { Checkbox } from '@process-advisor/process-miner/components/shared/checkbox';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { type ShowNodesProps } from '@process-advisor/process-miner/api/methods/settings/changeShowNodes';
import { Event } from '@process-advisor/process-miner/api/events';

const Wrapper = styled.div`
`;

export const Nodes = () => {
    const [showNodes, setShowNodes] = React.useState<ShowNodesProps>({});
    const onChange = _.curry((
        key: keyof ShowNodesProps,
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        const newShowNodes = { ...showNodes, [key]: e.target.checked };
        setShowNodes(newShowNodes);
        apiProvider.changeShowNodes(newShowNodes);
        apiProvider.rebuildPVDiagram({});
    });

    React.useEffect(() => {
        setShowNodes(apiProvider.getShowNodes());
    }, []);


    React.useEffect(() => {
        const listener = () =>
            setShowNodes(apiProvider.getShowNodes());
        listener();

        apiProvider.on(Event.loadProcessMinerSettings, listener);

        return () => {
            apiProvider.off(Event.loadProcessMinerSettings, listener);
        };
    }, []);

    return (
        <Wrapper>
            <Checkbox
                label='show start'
                checked={!!showNodes.start}
                handleOnChange={onChange('start')} />
            <Checkbox
                label='show end'
                checked={!!showNodes.end}
                handleOnChange={onChange('end')} />
        </Wrapper>
    );
};
